import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';

var getSelectedRow = function getSelectedRow(selectedRows, rowId, checked) {
  if (checked) {
    if (!Array.isArray(selectedRows)) {
      return [rowId];
    }
    return _toConsumableArray(new Set([].concat(_toConsumableArray(selectedRows), [rowId])));
  }
  return selectedRows.filter(function (selectedRow) {
    return selectedRow !== rowId;
  });
};
var getAllSelectedRows = function getAllSelectedRows(_ref) {
  var checked = _ref.checked,
    selectableRows = _ref.selectableRows,
    selectedRows = _ref.selectedRows;
  var selectableRowIds = selectableRows.map(function (row) {
    return row.id;
  });

  // add additional selected rows
  if (checked) {
    return Array.isArray(selectedRows) ? [].concat(_toConsumableArray(selectedRows), _toConsumableArray(selectableRowIds)) : selectableRowIds;
  }

  // remove the unselected rows
  return selectedRows.filter(function (row) {
    return !selectableRowIds.includes(row);
  });
};
var getSelectAllStatus = function getSelectAllStatus(selectedRows, selectableRows) {
  if (!Array.isArray(selectedRows)) {
    return false;
  }
  var foundSelectedRows = selectableRows.filter(function (row) {
    return selectedRows.includes(row.id);
  });
  return {
    isIntermediate: selectableRows.length !== foundSelectedRows.length,
    isSelectAllChecked: foundSelectedRows.length > 0
  };
};

export { getAllSelectedRows, getSelectAllStatus, getSelectedRow };
